export function fixMissingClosingBrace(raw: string): string {
  const open = (raw.match(/{/g) || []).length;
  const close = (raw.match(/}/g) || []).length;

  if (open > close) {
    return raw + '}'.repeat(open - close);
  }

  return raw;
}

export function safeParse(raw: string): any | null {
  try {
    return JSON.parse(raw);
  } catch {
    const fixed = fixMissingClosingBrace(raw);
    try {
      return JSON.parse(fixed);
    } catch {
      return null;
    }
  }
}
